import HealthCheckPage from './HealthCheck';
export default HealthCheckPage; 